import actionTypes from "../../../common/store/actionTypes";

export const setCore = (payload) =>
    ({ type: actionTypes.app.updateState, payload });

export const actions = {
    setCore,
};
